import {
  Button,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from "../../../utils/axios";
import SettlementIssuerWiseModal from "./SettlementIssuerWiseModal";

const SettlementConfirmation = () => {
  const { id } = useParams();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIssuerId, setSelectedIssuerId] = useState(null);
  const [selectedIssuerName, setSelectedIssuerName] = useState(null);
  const [selectedFundTransferId, setSelectedFundTransferId] = useState(null);
   const location = useLocation();

   console.log(location.state.refNo);

  // Fetch API Data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await axios.get(
          `/settled-eft-summary/request/${id}`
        );

        if (res.data?.success) {
          setData(res.data.payload);
        } else {
          Swal.fire("Error", "No data found", "error");
        }
      } catch (error) {
        Swal.fire("Error", "API failed", "error");
      }

      setLoading(false);
    };

    fetchData();
  }, [id]);

  // Table Column Setup
 const columns = [
  {
    accessorKey: "sl",
    header: "SL",
    Cell: ({ row }) => row.index + 1,
    size: 10,
  },

  {
    accessorKey: "refNo",
    header: "Ref No",
  },

  // {
  //   accessorKey: "subject",
  //   header: "Subject",
  // },

  {
    accessorKey: "paymentDate",
    header: "Payment Date",
    Cell: ({ row }) =>
      row.original.paymentDate
        ? new Date(row.original.paymentDate).toLocaleDateString()
        : "",
  },

  {
    accessorKey: "issuer",
    header: "Issuer Name",
    Cell: ({ row }) => row.original.issuer?.name,
  },

  // {
  //   accessorKey: "request",
  //   header: "Request Ref No",
  //   Cell: ({ row }) => row.original.request?.refNo,
  // },

  {
    accessorKey: "totalInvestors",
    header: "Total Investors",
  },

  {
    accessorKey: "totalAmount",
    header: "Total Amount",
  },

  {
    header: "Action",
    Cell: ({ row }) => (
      <Button
        variant="outlined"
        onClick={() => {
          setSelectedIssuerId(row.original.issuer?.id);
          setSelectedIssuerName(row.original.issuer?.name);
          setSelectedFundTransferId(row.original.request.id);
          setModalOpen(true);
        }}
      >
        View
      </Button>
    ),
  },
];


  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ marginBottom: "10px" }}
      >
        <Grid item>
          <PageTitle title="Settlement Confirmation" />
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.push("/app/eft/fundTransferRequestList",
              {restoreState:true,prevState:location.state.prevState})}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
            <h3 style={{ marginBottom: "10px" }}>
            <strong>Reference No:</strong> {location.state.refNo} <br></br> <strong>Amount:</strong> {new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(location.state.amount) || 0)}
          </h3>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <CircularProgress />
        </div>
      ) : (

         
        <MaterialReactTable columns={columns} 
        data={data}
         initialState={{ density: 'compact' }} />
      )}

      {/* Modal Component */}
      <SettlementIssuerWiseModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        issuerId={selectedIssuerId}
        issuerName={selectedIssuerName}
        fundTransferRequestId={selectedFundTransferId}
      />
    </>
  );
};

export default SettlementConfirmation;
